import CopyHelper from 'components/AccountDetails/Copy'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { useMICCOntract, useTokenContract } from 'hooks/useContract'
import { useCallback, useEffect, useState } from 'react'
import { NavLink, RouteComponentProps } from 'react-router-dom'
import { shortenAddress } from 'utils'
import { useWalletModalToggle } from 'state/application/hooks'
import Web3Status from 'components/Web3Status'
import Polling from 'components/Header/Polling'

export default function Referral({}: RouteComponentProps) {
  const { account, chainId } = useActiveWeb3React()
  const [referrals, setRefferals] = useState([])
  const [crystals, setCrystals] = useState({ blue: 0, red: 0 })
  const [showLink, setShowLink] = useState(false)

  const contract = useMICCOntract(true)
  //rinkeby test network
  // const redCrystalContract = useTokenContract('0x306BDfAB1272326Ba1fe27499bB6f2a573ca1b16', true)
  // const blueCrystalContract = useTokenContract('0x98362ec38F7faE5F71D2aF0f4B91bA7D8a1b7dF1', true)

  const redCrystalContract = useTokenContract('0x5C6CBe357514E797EcAE008D316A64b87d81DE75', true)
  const blueCrystalContract = useTokenContract('0x0d2f366554ef1895173d6D5148E4fA50f9b0e5c9', true)
  const micTokenContract = useTokenContract('0x7A3a87E1aD0Be9EbeCAE78D1B96E74fD359A1F72', true)

  const toggleWalletModal = useWalletModalToggle()
  const [mobile, setMobile] = useState(false)
  const [checkMiC, setCheckMic] = useState(0)

  const { library } = useActiveWeb3React()

  const [success, setSuccess] = useState<boolean | undefined>()

  const loadData = async () => {
    try {
      if (account) {
        const referrals = await contract?.getCurrentReferrals()
        setRefferals(referrals)
        const red = await redCrystalContract?.balanceOf(account)
        const blue = await blueCrystalContract?.balanceOf(account)
        const mic = await micTokenContract?.balanceOf(account)
        setCheckMic(Number(mic) / 10 ** 18)

        if (Number(red) / 10 ** 18 > 0 || Number(blue) / 10 ** 18 > 0) {
          if (!localStorage.getItem('bluecrystal') && Number(blue) > 0) {
            localStorage.setItem('bluecrystal', 'added')
            addToken({ address: blueCrystalContract?.address, symbol: 'MIC Blue Crystal' })
          }

          if (!localStorage.getItem('redcrystal') && Number(red) > 0) {
            localStorage.setItem('redcrystal', 'added')
            addToken({ address: redCrystalContract?.address, Symbol: 'MIC Red Crystal' })
          }
        }

        setCrystals({ blue: Number(blue) / 10 ** 18, red: Number(red) / 10 ** 18 })
      }
    } catch (e) {
      console.log(e.error)
    }
  }

  const addToken = useCallback(
    (tokendetails) => {
      if (library && library?.provider?.isMetaMask && library.provider.request) {
        library.provider
          .request({
            method: 'wallet_watchAsset',
            params: {
              //@ts-ignore // need this for incorrect ethers provider type
              type: 'ERC20',
              options: {
                address: tokendetails.address,
                symbol: tokendetails.symbol,
                decimals: 18,
                image: 'logoURL',
              },
            },
          })
          .then((success) => {
            setSuccess(success)
          })
          .catch(() => setSuccess(false))
      } else {
        setSuccess(false)
      }
    },
    [library]
  )

  useEffect(() => {
    if (account) {
      loadData()
    }

    // red?
    // setCrystals([red, blue])
  }, [account])

  return (
    // <div className="referral">
    //   <div className="container">
    <>
      <div className="referral" style={{ backgroundColor: 'black' }}>
        <div className="container">
          <nav className="navbar navbar-expand-lg fixed-top center-brand static-nav">
            <div className="container-fluid d-flex align-content-center justify-content-between">
              <NavLink className="navbar-brand" to="/">
                <img src="img/logo.png" alt="logo" className="logo-custom" />
              </NavLink>
              <ul
                className={
                  !mobile
                    ? 'navbar-1 align-items-sm-center  d-none d-sm-flex '
                    : 'navbar-1 align-items-sm-center  d-sm-flex header__top-nav'
                }
              >
                <li className="nav-item">
                  <NavLink className="nav-link" to="buy" onClick={() => setMobile(false)}>
                    BUY MIC
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink to={'referral'} className="nav-link" onClick={() => setMobile(false)}>
                    REFERRAL
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink to={'faq'} className="nav-link" onClick={() => setMobile(false)}>
                    FAQ
                  </NavLink>
                </li>

                <Web3Status />
              </ul>
              <div onClick={() => setMobile(!mobile)} className="menu dots d-sm-none d-inline" />
            </div>
          </nav>

          <section
            className="referral-sec my-auto flex-wrap flex-row d-flex align-content-center justify-content-center"
            id="feature"
            style={{ marginTop: '10px' }}
          >
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-4 text-center">
                  <div className="referral-card fix-h">
                    <img src="/img/generate-img.png" alt=" " />
                    <h1>GENERATE LINK</h1>
                    <p>Generate Your Link</p>
                  </div>
                </div>
                <div className="col-md-4 text-center">
                  <div className="referral-card fix-h position-relative">
                    <img src="/img/share-img.png" />
                    <h1>SHARE LINK</h1>
                    <p>Refer Two People To Buy MIC Token</p>
                    <img className="position-absolute" src="/img/arrow.png" />
                    <img className="position-absolute" src="/img/arrow.png" />
                  </div>
                </div>
                <div className="col-md-4 text-center">
                  <div className="referral-card fix-h">
                    <img src="/img/crystals2-img.png" />
                    <h1>GET REWARDS</h1>
                    <p>Receive Two Free Charge Crystal</p>
                  </div>
                </div>
                <div className="col-lg-8 col-sm-12">
                  <div className="referral-card">
                    <h1>YOUR WALLET ADDRESS</h1>
                    <div className="row">
                      <div className="col-md-9">
                        <div className="mic-round d-flex justify-content-between align-items-center">
                          <span className="text-white valign">{account ? account : 'Please connect'}</span>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <a className="btn" onClick={() => (account ? setShowLink(true) : toggleWalletModal())}>
                          GENERATE
                        </a>
                      </div>
                    </div>
                    <h1 className="pt-4">YOUR REFERRAL LINK</h1>
                    <div className="row">
                      <div className="col-md-9">
                        <div className="mic-round d-flex justify-content-between align-items-center">
                          {checkMiC > 0 ? (
                            <span className="text-white valign">
                              {showLink && account ? (
                                <>https://metainvisiblecloak.com?ref={shortenAddress(account)}</>
                              ) : (
                                <> Click generate to get your referral link</>
                              )}
                            </span>
                          ) : (
                            <span className="text-white valign">
                              <> You need to purchase MIC tokens first</>
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-md-3">
                        {account ? (
                          <a
                            className={`btn ref text-center ${showLink && checkMiC > 0 ? '' : 'disabled'}`}
                            style={{ margin: 'auto' }}
                          >
                            <CopyHelper
                              toCopy={account ? 'https://metainvisiblecloak.com?ref=' + account : ''}
                              iconPosition="left"
                            >
                              Copy Link
                            </CopyHelper>
                          </a>
                        ) : (
                          <a href="#" onClick={toggleWalletModal} className={`btn ref text-center`}>
                            Connect
                          </a>
                        )}
                      </div>
                    </div>
                    <div className="row pt-3">
                      <div id="accordion">
                        <div
                          className="text-white collapsed"
                          data-toggle="collapse"
                          data-target="#collapseOne"
                          aria-expanded="false"
                          aria-controls="collapseOne"
                        >
                          YOUR REFERRALS <span className="dropdown-toggle" />
                        </div>
                        <div
                          id="collapseOne"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingOne"
                          data-parent="#accordion"
                          style={{}}
                        >
                          <div className="d-flex justify-content-between pt-3">
                            <div className="text-white fw-bold">WALLET ADDRESS </div>
                            <div className="text-white fw-bold"> REWARD</div>
                          </div>

                          {referrals ? (
                            referrals.map((ref, i) => (
                              <div className="d-flex justify-content-between" key={i}>
                                <div className="text-white">{shortenAddress(ref)}</div>
                                <div className="text-white">
                                  {i == 0 ? '1 BLUE CRYSTAL' : i == 1 ? '1 RED CRYSTAL' : ''}
                                </div>
                              </div>
                            ))
                          ) : (
                            <div>You have no referrals</div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-12">
                  <div className="referral-card">
                    <h1>YOUR CHARGE CRYSTALS</h1>
                    <p>Maximum of only two crystals per wallet.</p>
                    <div className="crystals-ref-img d-flex">
                      <img
                        src="/img/crystal-1.png"
                        style={{ opacity: `${crystals.blue > 0 ? 1 : 0.3}` }}
                        className="crystals-ref-img"
                      />
                      <img
                        src="/img/crystal-2.png"
                        style={{ opacity: `${crystals.red > 0 ? 1 : 0.3}` }}
                        className="crystals-ref-img"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <Polling />
        </div>
      </div>
    </>
  )
}
